<template>
        <div v-if="this.$store.getters.GetBlock.notifications"></div>
        <div v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.transport" class="uk-container uk-container-center uk-text-center uk-margin-top " style="background-image: none;" uk-scrollspy="cls:uk-animation-slide-bottom;">
        <h1 class="uk-heading" id="transp">{{ this.$store.getters.GetText.transport.title[this.$store.getters.Lang]}}</h1>
        <div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin " uk-grid uk-scrollspy="cls:uk-animation-slide-right;">
            <div class="uk-card-media-left uk-cover-container">
                <img src="../assets/img/transport/airplane_s.png" alt="" uk-cover>
                <canvas width="300" height="300"></canvas>
            </div>
            <div>
                <div class="uk-card-body">
                    <h3 class="uk-card-title">{{ this.$store.getters.GetText.transport.b1title[this.$store.getters.Lang]}}</h3>
                    <p>{{ this.$store.getters.GetText.transport.b1text[this.$store.getters.Lang]}}</p>
                    <a class="uk-button uk-button-primary" href="https://airtickets.kja.aero/" target="blank">{{this.$store.getters.GetText.transport.b1but[this.$store.getters.Lang]}}</a>
                </div>
            </div>
        </div>

        <div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin " uk-grid uk-scrollspy="cls:uk-animation-slide-left;">
            <div class="uk-flex-last@s uk-card-media-right uk-cover-container">
                <img src="../assets/img/transport/tram_s.png" alt="" uk-cover>
                <canvas width="300" height="300"></canvas>
            </div>
            <div>
                <div class="uk-card-body">
                    <h3 class="uk-card-title">{{ this.$store.getters.GetText.transport.b2title[this.$store.getters.Lang]}}</h3>
                    <p>{{this.$store.getters.GetText.transport.b2text[this.$store.getters.Lang]}}
                    </p>
                    <a class="uk-button uk-button-primary" href="https://www.rzd.ru/" target="blank">{{this.$store.getters.GetText.transport.b2but[this.$store.getters.Lang]}}</a>
                </div>
            </div>
        </div>
    </div>    
</template>